/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AcknowledgeRiskPolicyChallengeRequestBody,
  AcknowledgeRiskPolicyChallengeRequestBody$Outbound,
  AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema,
} from "../components/acknowledgeriskpolicychallengerequestbody.js";

export type AcknowledgeRiskPolicyChallengeSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type AcknowledgeRiskPolicyChallengeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  acknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody;
};

/** @internal */
export type AcknowledgeRiskPolicyChallengeSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AcknowledgeRiskPolicyChallengeSecurity$outboundSchema:
  z.ZodMiniType<
    AcknowledgeRiskPolicyChallengeSecurity$Outbound,
    AcknowledgeRiskPolicyChallengeSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function acknowledgeRiskPolicyChallengeSecurityToJSON(
  acknowledgeRiskPolicyChallengeSecurity:
    AcknowledgeRiskPolicyChallengeSecurity,
): string {
  return JSON.stringify(
    AcknowledgeRiskPolicyChallengeSecurity$outboundSchema.parse(
      acknowledgeRiskPolicyChallengeSecurity,
    ),
  );
}

/** @internal */
export type AcknowledgeRiskPolicyChallengeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AcknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody$Outbound;
};

/** @internal */
export const AcknowledgeRiskPolicyChallengeRequest$outboundSchema:
  z.ZodMiniType<
    AcknowledgeRiskPolicyChallengeRequest$Outbound,
    AcknowledgeRiskPolicyChallengeRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      acknowledgeRiskPolicyChallengeRequestBody:
        AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        acknowledgeRiskPolicyChallengeRequestBody:
          "AcknowledgeRiskPolicyChallengeRequestBody",
      });
    }),
  );

export function acknowledgeRiskPolicyChallengeRequestToJSON(
  acknowledgeRiskPolicyChallengeRequest: AcknowledgeRiskPolicyChallengeRequest,
): string {
  return JSON.stringify(
    AcknowledgeRiskPolicyChallengeRequest$outboundSchema.parse(
      acknowledgeRiskPolicyChallengeRequest,
    ),
  );
}
